import { useState, useEffect } from 'react';
import HubSpotIcon from '../../images/hubspot.png'
import IntercomIcon from '../../images/intercom.png'
import {capitalize} from "@mui/material";

function AnnotatedContentCard({idea}) {

  const [lines, setLines] = useState([]);
  const [subjectLines, setSubjectLines] = useState([]);
  const [dateNow, setDateNow] = useState(null);
  const [checkList, setCheckList] = useState([])

  const handleIcon = (id) => {
    switch (id) {
      case 'HubSpot':
        return (
          <img className="rounded-full bg-white mr-2" src={HubSpotIcon} width="36" height="36" />
        );
      case 'Intercom':
        return (
          <img className="rounded-full bg-white mr-2" src={IntercomIcon} width="36" height="36" />
        );
      default:
        return (
          <svg className="flex-shrink-0 mr-2 sm:mr-3" width="36" height="36" viewBox="0 0 36 36">
            <circle fill="#24292E" cx="18" cy="18" r="18" />
            <path d="M18 10.2c-4.4 0-8 3.6-8 8 0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4V24c-2.2.5-2.7-1-2.7-1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6-.2 1.3-.3 2-.3s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.4.6.9.6 1.6v2.2c0 .2.1.5.6.4 3.2-1.1 5.5-4.1 5.5-7.6-.1-4.4-3.7-8-8.1-8z" fill="#FFF" />
          </svg>
        );
    }
  };

  useEffect(() => {
    OnLoad();
    setDateNow(getDate())
    console.log(idea)
  }, [idea]);


  function OnLoad() {
    if(idea!=null){
      var subjectLine = ''
      var match = null
      var emailLines = []
      var subject = []
      var splitText = []
      if(idea.email.includes('body:'))
        splitText = idea.email.toLowerCase().split('body:')
      else if(idea.email.includes('Body:'))
        splitText = idea.email.split('Body:')

      console.log(splitText)
      if(splitText.length>1){
        var subjectLine = splitText[0].replace('Subject:', '').replace('subject:', '')
        var body = splitText[1]
        // subject
        match = subjectLine.match(/(?!\[)-?\d+(?=\])/g)
        if (match != null) {
          for (var i in match) {
            var idx = subjectLine.indexOf('[' + match[i] + ']')
            switch (match[i]) {
              case '1':
                subject.push(<mark
                    className="bg-indigo-100
                   text-indigo-600 rounded-full px-2.5 py-1">{subjectLine.substring(0, idx).trim()}</mark>)
                subjectLine = subjectLine.substring(idx + 3, subjectLine.length).trim()
                break
              case '2':
                subject.push(<mark
                    className="bg-sky-100
                   text-sky-600 rounded-full px-2.5 py-1">{subjectLine.substring(0, idx).trim()}</mark>)
                subjectLine = subjectLine.substring(idx + 3, subjectLine.length).trim()
                break
              case '3':
                subject.push(<mark
                    className="bg-red-100
                   text-red-600 rounded-full px-2.5 py-1">{subjectLine.substring(0, idx).trim()}</mark>)
                subjectLine = subjectLine.substring(idx + 3, subjectLine.length).trim()
                break
              case '4':
                subject.push(<mark
                    className="bg-yellow-100
                   text-yellow-600 rounded-full px-2.5 py-1">{subjectLine.substring(0, idx).trim()}</mark>)
                subjectLine = subjectLine.substring(idx + 3, subjectLine.length).trim()
                break
            }
            // print out the remaining part of the line if last element

            if (parseInt(i) + 1 === match.length) {
              subject.push(subjectLine)
            }
          }
        } else {
          subject.push(subjectLine)
        }
        // body
        console.log('split body')
        console.log(body.split('.'))
        for (var line of body.split('.')) {
          line = line+'. '
          match = line.match(/(?!\[)-?\d+(?=\])/g)
          if (match != null) {
            for (var i in match) {
              var idx = line.indexOf('[' + match[i] + ']')
              switch (match[i]) {
                case '1':
                  emailLines.push(<mark
                      className="bg-indigo-100
                     text-indigo-600 rounded-full px-2.5 py-1">{line.substring(0, idx).trim()}</mark>)
                  line = line.substring(idx + 3, line.length).trim()
                  break
                case '2':
                  emailLines.push(<mark
                      className="bg-sky-100
                     text-sky-600 rounded-full px-2.5 py-1">{line.substring(0, idx).trim()}</mark>)
                  line = line.substring(idx + 3, line.length).trim()
                  break
                case '3':
                  emailLines.push(<mark
                      className="bg-red-100
                     text-red-600 rounded-full px-2.5 py-1">{line.substring(0, idx).trim()}</mark>)
                  line = line.substring(idx + 3, line.length).trim()
                  break
                case '4':
                  emailLines.push(<mark
                      className="bg-yellow-100
                     text-yellow-600 rounded-full px-2.5 py-1">{line.substring(0, idx).trim()}</mark>)
                  line = line.substring(idx + 3, line.length).trim()
                  break
              }
              // print out the remaining part of the line if last element

              if (parseInt(i) + 1 === match.length) {
                emailLines.push(line)
              }
            }
          } else {
            emailLines.push(line)
          }
        }
      }
      setLines(emailLines)
      setSubjectLines(subject)

      // Populate the checklist
      /*for(var item in check)*/
      if(idea.checklist.includes('\n')){
        var items = idea.checklist.split('\n')
        console.log(items)
        console.log(idea)
      }

    }else{
      setSubjectLines([])
      setLines([])
      setDateNow(null)
    }
  }

  function getDate(){
    var today  = new Date();
    return today.toLocaleDateString('en-GB')
  }
  return (
      <div className="bg-white shadow-1 rounded-sm border
                    border-gray-200 px-6 divide-y divide-slate-200 w-2/3 m-auto my-5">
        <div className="py-6">
          <div className="flex justify-center -m-1.5 w-full">
            <h3>✉️ 1 New Email</h3>
          </div>
        </div>
        {subjectLines.length>0?<div className="py-6">
          <div className="flex justify-center -m-1.5 w-full mb-5">
            <div className="m-1.5">

              <div
                  className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">CTA: {idea!=null ? idea.cta : ''}</div>

            </div>
            <div className="m-1.5">

              <div
                  className="text-xs inline-flex font-medium bg-sky-100 text-sky-600 rounded-full text-center px-2.5 py-1">Urgency: {idea!=null ? idea.urgency : ''}</div>

            </div>
            <div className="m-1.5">

              <div
                  className="text-xs inline-flex font-medium bg-red-100 text-red-600 rounded-full text-center px-2.5 py-1">Tone: {idea!=null? idea.tone : ''}</div>

            </div>
            <div className="m-1.5">

              <div
                  className="text-xs inline-flex font-medium bg-yellow-100 text-yellow-600 rounded-full text-center px-2.5 py-1">Topic: {idea!=null ? idea.topic : ''}</div>
              </div>
            {idea.website_url!=''?<div className="m-1.5">

              <div
                  className="text-xs inline-flex font-medium bg-yellow-100 text-yellow-600 rounded-full text-center px-2.5 py-1">Web: {idea.website_url}</div>
            </div>:''}
          </div>
          {/* Header */}
          <header className="flex">
            {/* Avatar */}
            <div className="flex items-center">
              {handleIcon('HubSpot')}
            </div>
            {/* Meta */}
            <div className="w-full">
              <div className="flex justify-between mb-0.5">
                <div className="flex items-center mb-2 sm:mb-0">
                  <button
                      className="text-sm font-semibold text-slate-800 text-left truncate">{subjectLines ? subjectLines : ''}</button>
                </div>
                <div
                    className="text-xs font-medium text-slate-500 whitespace-nowrap mb-2 mb-0">{dateNow != null ? dateNow : ''}</div>
              </div>
              <div className="text-xs font-medium text-slate-500">from: your@email.com</div>
            </div>
          </header>
          <div className="text-sm text-slate-800 mt-4 space-y-2">
            {idea!=null?
            <img
                className="object-cover object-center w-2/5 h-2/5 cursor-pointer float-right px-5 pb-2 pt-2"
                src={idea.image_url}
                width="220"
                height="236"
                alt="Meetup 01"
            />:''}
            <p className="text-justify">{lines != null ? lines : ''}</p>
          </div>
          <footer className="flex text-sm text-slate-800 mt-4 space-y-2 justify-end">
            <small>This is an AI generated sample personalized to your use-case. Make it your own!</small>
          </footer>
        </div>:
            <div className="flex flex-col h-full text-center p-5 overflow-hidden">
              <div className="grow mb-1">
                <div className="m-auto text-center mb-2">
                  <svg className="animate-spin h-5 w-full" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" stroke="#0F172A" strokeWidth="6" fill="transparent" strokeLinecap="round"
                    strokeDasharray="283" strokeDashoffset="75"/>
                  </svg>
                </div>
              </div>
            </div>}
      </div>
  );
}

export default AnnotatedContentCard;
